import { render, staticRenderFns } from "./balance_data.vue?vue&type=template&id=bc420070&scoped=true"
import script from "./balance_data.vue?vue&type=script&lang=js"
export * from "./balance_data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc420070",
  null
  
)

export default component.exports